import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from './useAuth'

function PrivateRoutes() {
    const token = useAuth();
    //console.log(token);
    return token ? <Outlet /> : <Navigate to='/' />
}

export default PrivateRoutes

